/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { colors } from '@atlaskit/theme';
import { FormSpy } from '../../../components/form';
import { Sale } from '../types';
import SaleInvoicePreview from '../SaleInvoicePreview';
import { useCurrentCompany } from '../../auth/CurrentCompany';

type Props = {
  isLoading: boolean;
}

const columnCss = css`flex: 1`;
const rowCss = css`display: flex`;

const SaleEditSplitPane: React.FC<Props> = ({children, isLoading}) => {
  const company = useCurrentCompany();

  return (
    <div css={rowCss}>
      <div css={css`/*width: 700px;*/ flex: 1; overflow: scroll; height: 100vh;`}>
        {children}
      </div>
      <div css={[columnCss, css`overflow: scroll; height: 100vh; background: #FAFBFC; border-left: 2px solid ${colors.backgroundHover()};`]}>
        {!isLoading && <FormSpy<Sale> subscription={{ values: true }}>
          {({ values }) => {
            return (
              <SaleInvoicePreview invoice={values} invoiceSettings={company?.invoiceSettings} />
            );
          }}
        </FormSpy>}
      </div>
    </div>
  );
};

export default SaleEditSplitPane;
